import React from 'react';
import { Box, Divider, Paper, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import CustomRankingChart, { DadoRanking } from '../../../components/customRankingChart/CustomRankingChart';
import Loading from '../../../components/loading/Loading';
import './RankingChartCard.css';

const OPCOES_RANKING = [3, 5, 10, 15];

type RankingChartCardProps = {
  isLoading: boolean;
  dados: DadoRanking[];
  titulo: string;
  subtitulo: string;
  tituloQuantidade?: string;
  rotuloValorExtra?: string;
  formatarValorExtra?: (valor: number) => string;
  limiteRanking: number;
  onLimiteRankingChange: (limite: number) => void;
  emptyIcon: React.ReactNode;
  emptyTitle: string;
  emptyDescription: string;
};

function RankingChartCard({
  isLoading,
  dados,
  titulo,
  subtitulo,
  tituloQuantidade = 'Qtd. Vendida',
  rotuloValorExtra,
  formatarValorExtra,
  limiteRanking,
  onLimiteRankingChange,
  emptyIcon,
  emptyTitle,
  emptyDescription,
}: RankingChartCardProps) {
  return (
    <Paper elevation={0} className='indicadores-paper indicadores-chart-paper'>
      <Box className='indicadores-chart-header'>
        <Box className='ranking-chart-header-content'>
          <Typography className='indicadores-chart-title'>{titulo}</Typography>
          <Typography
            className='indicadores-chart-subtitle ranking-chart-subtitle'
            title={subtitulo}
          >
            {subtitulo}
          </Typography>
        </Box>
      </Box>

      <Divider className='indicadores-divider' />

      {isLoading ? ( 
        <Loading />
      ) : dados.length === 0 ? (
        <Box className='indicadores-empty-state'>
          <Box>
            {emptyIcon}
            <Typography className='indicadores-empty-title'>{emptyTitle}</Typography>
            <Typography className='indicadores-empty-description'>{emptyDescription}</Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pl: 0, pr: 0 }}>
            <ToggleButtonGroup
              value={limiteRanking}
              exclusive
              orientation='vertical'
              size='small'
              onChange={(_e, valor) => {
                if (valor !== null) onLimiteRankingChange(valor);
              }}
              sx={{ borderRadius: 1, padding: 0, paddingLeft: 2, paddingRight: -16, mt: 0, mb: 3 }}
            >
              {OPCOES_RANKING.map((opcao) => (
                <ToggleButton
                  key={opcao}
                  value={opcao}
                  sx={{ fontSize: 9, px: 1, py: 0.4, textTransform: 'none', fontWeight: 600, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', lineHeight: 2 }}
                >
                  {'<='} {opcao}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
          <Box className='indicadores-chart-wrap' sx={{ flex: 1, minWidth: 0 }}>
            <CustomRankingChart
              dados={dados}
              altura={200}
              tituloQuantidade={tituloQuantidade}
              rotuloValorExtra={rotuloValorExtra}
              formatarValorExtra={formatarValorExtra}
            />
          </Box>
        </Box>
      )}
    </Paper>
  );
}

export default React.memo(RankingChartCard);